import { Fragment } from "react";
import HiringSection from "../../components/Hiring/HiringSection";
import "./AboutPage.css";
import DoneIcon from "@mui/icons-material/Done";
import ChatIcon from "@mui/icons-material/Chat";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import WebhookIcon from "@mui/icons-material/Webhook";
import aboutbanner from "../../assets/images/about/aboutbanner.png";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";

const AboutPage = () => {
  return (
    <Fragment>
      <BreadCrumb title={"About Us"} currentpageTitle={"About Us"} />
      <section className="aboutpage-style">
        <div className="aboutpage-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="aboutpage-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Who is <span className="title-gradient">Kairaa</span> Tech
                  Serve?{" "}
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="400"
                  data-aos-duration="1200"
                >
                  Kairaa is the best company for serving tech solutions. We'll
                  develop enterprise solutions using web 3.0 technologies. Our
                  solutions will aid in our clients' management and business
                  optimization. To assist our clients in achieving their
                  business objectives, we can offer the best technological
                  solutions. Our web 3.0 experts are committed to pioneering
                  next-gen technologies and solving real-world challenges. More
                  than just a tech provider, Kairaa is a trusted partner
                  dedicated to creating transformative digital experiences
                  through innovation.
                </p>
                <div className="mt-35">
                  <div
                    className="about-btn-fill"
                    data-aos="fade-up"
                    data-aos-delay="400"
                    data-aos-duration="1200"
                  >
                    <a href="/about">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="image-blend-wrapper">
                <img
                  src={aboutbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="aboutpage-service">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <h1
                  className="text-start"
                  data-aos="fade-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Why you should need
                  <span className="title-gradient"> Kairaa</span>
                </h1>
              </div>
              <div className="col-lg-4">
                <p
                  className="aboutpage-service-desc"
                  data-aos="fade-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  For companies and individuals who need to be on the cutting
                  edge and have access to the most recent technology, Kairaa
                  tech services are the ideal solution.
                </p>
              </div>
            </div>

            <div className="service-big-numbers container">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div
                    className="service-item"
                    data-aos="zoom-in"
                    data-aos-delay="200"
                    data-aos-duration="1000"
                  >
                    <h2 className="service-number">01</h2>
                    <h3 className="service-title">New Tech's</h3>
                    <p>Utilize latest technologies</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div
                    className="service-item"
                    data-aos="zoom-in"
                    data-aos-delay="400"
                    data-aos-duration="1200"
                  >
                    <h2 className="service-number">02</h2>
                    <h3 className="service-title">Support</h3>
                    <p>Best in tech support</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div
                    className="service-item"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-duration="1400"
                  >
                    <h2 className="service-number">03</h2>
                    <h3 className="service-title">Service</h3>
                    <p>Quality is our top concern</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div
                    className="service-item"
                    data-aos="zoom-in"
                    data-aos-delay="800"
                    data-aos-duration="1600"
                  >
                    <h2 className="service-number">04</h2>
                    <h3 className="service-title">Team</h3>
                    <p>Having qualified experts</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="aboutpage-tech-section">
              <div className="container">
                <div className="row align-items-center">
                  {/* Left Visual */}
                  <div className="col-lg-5 col-md-12">
                    <div className="visual-left">
                      <div className="circle-bg"></div>
                      <div className="floating-box box1">
                        <span>
                          <WebhookIcon />
                        </span>
                      </div>
                      <div className="floating-box box2">
                        <span>
                          <ChatIcon />
                        </span>
                      </div>
                      <div className="floating-box box3">
                        <span>
                          <SettingsSuggestIcon />
                        </span>
                      </div>
                      <div className="floating-box box4">
                        <span>
                          <Diversity1Icon />
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Right Content */}
                  <div className="col-lg-7 col-md-12">
                    <div>
                      <h1
                        data-aos="fade-left"
                        data-aos-delay="200"
                        data-aos-duration="1000"
                      >
                        Kairaa is Ready to Find a
                        <span className="title-gradient"> Solution</span>
                      </h1>
                      <p
                        data-aos="fade-left"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                      >
                        Kairaa is ready to find a solution for your innovative
                        idea's. Our team of engineers is experienced in a wide
                        range of technologies and can help you turn your vision
                        into a reality. Our solutions are custom-tailored to
                        your industry, so we make it easy to implement the right
                        solution for your business. Kairaa approaches each
                        project by thoroughly understanding the client's unique
                        business goals, industry specifics, and competitive
                        landscape. This deep understanding enables us to design
                        solutions that are truly aligned with the client’s needs
                        and challenges.
                      </p>
                      <div className="row">
                        <div className="col-lg-6">
                          <p
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1000"
                          >
                            <span>
                              <DoneIcon /> Latest Technologies
                            </span>
                          </p>
                        </div>
                        <div className="col-lg-6">
                          <p
                            data-aos="fade-up"
                            data-aos-delay="400"
                            data-aos-duration="1200"
                          >
                            <span>
                              <DoneIcon /> Quality Tech Services
                            </span>
                          </p>
                        </div>
                        <div className="col-lg-6">
                          <p
                            data-aos="fade-up"
                            data-aos-delay="600"
                            data-aos-duration="1400"
                          >
                            <span>
                              <DoneIcon /> Wide Rang of Services
                            </span>
                          </p>
                        </div>
                        <div className="col-lg-6">
                          <p
                            data-aos="fade-up"
                            data-aos-delay="800"
                            data-aos-duration="1600"
                          >
                            <span>
                              <DoneIcon /> Customer Experience
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <HiringSection />
    </Fragment>
  );
};
export default AboutPage;
